/*
 *
 * DrawersPanel constants
 *
 */

enum ActionTypes {
  DISPLAY_DRAWERS_COMPOSITION_PANEL = 'app/DrawersCompositionPanel/DISPLAY_DRAWERS_COMPOSITION_PANEL',
  DRAWERS_CHOICE = 'app/DrawersPanel/DRAWERS_CHOICE',
}

export const DRAWERS_COMPOSITION: any = {
  100: [[100]],
  135: [[135]],
  170: [[170]],
  200: [[200], [100, 100]],
  270: [[270], [135, 135], [170, 100]],
  370: [[370], [200, 170], [170, 100, 100], [135, 135, 100], [270, 100]],
  470: [
    [370, 100],
    [270, 200],
    [270, 100, 100],
    [200, 135, 135],
    [200, 170, 100],
    [170, 100, 100, 100],
    [135, 135, 100, 100],
  ],
};

export default ActionTypes;
